import { render, staticRenderFns } from "./CustomerMergeDialog.vue?vue&type=template&id=1c865e4c&scoped=true"
import script from "./CustomerMergeDialog.vue?vue&type=script&lang=ts"
export * from "./CustomerMergeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c865e4c",
  null
  
)

export default component.exports